import React from "react"
import { basketPageDataQuery } from "../../contents/basket/queries"
import { fetchShippingPageData } from "../../contents/shipping/fetch"
import GenericSEO from "../../features/seo/components/GenericSEO"
import OrderDetailsContainer from "../../containers/orders/OrderDetails"
import { wrapPage } from "../../aggregators/page"
import { DefaultLayout } from "../../layouts/Default/DefaultLayout"
import { WrapPage } from "../../root"

interface Props {
  rootData: any
}

export default function OrderPage({ rootData }: Props) {
  return (
    <WrapPage rootData={rootData}>
      <DefaultLayout contentFlex>
        <OrderDetailsContainer />
      </DefaultLayout>
      <GenericSEO
        title="Dettaglio ordine"
        description="Dettaglio ordine"
        noIndex
      />
    </WrapPage>
  )
}

export async function getServerSideProps({ locale }: any) {
  return await wrapPage({
    locale,
    fetchProps: async (languageId: string) => {
      const contents = await fetchShippingPageData({
        query: basketPageDataQuery,
        languageId,
      })
      return {
        contents,
        languageId,
      }
    },
  })
}
